export default __webpack_public_path__ + "static/gap-81325ca11b5d2e693f01166cb34a3c2a.png";